// Le Chic Beauty theme behavior: navigation, Shopify cart drawer, homepage modules.

// ---------- Mobile nav ----------
const toggle = document.querySelector('.nav-toggle');
const nav = document.getElementById('site-nav');

function setNav(open) {
  document.body.classList.toggle('nav-open', open);
  toggle.setAttribute('aria-expanded', String(open));
  toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
}
if (toggle && nav) {
  toggle.addEventListener('click', () => setNav(!document.body.classList.contains('nav-open')));
  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setNav(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setNav(false); });
}

// ---------- Header shadow on scroll ----------
const header = document.querySelector('.site-header');
if (header) {
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// ---------- Header search ----------
if (LC.initSearch) LC.initSearch();

// ---------- Toast ----------
const toast = document.querySelector('.toast');
let toastTimer;
function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 2600);
}

// ---------- Bag drawer on the Shopify cart ----------
LC.bag = (() => {
  const e = LC.escape;
  const cartBtn = document.querySelector('.cart-btn');
  const countEl = cartBtn && cartBtn.querySelector('.cart-count');
  const money = (cents) => LC.formatPrice(cents / 100);
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const drawer = document.createElement('div');
  drawer.className = 'drawer';
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML = `
    <div class="drawer-scrim" data-close></div>
    <aside class="drawer-panel" role="dialog" aria-modal="true" aria-labelledby="drawer-title">
      <div class="drawer-head">
        <h2 id="drawer-title">Your Bag</h2>
        <button type="button" class="drawer-close" data-close aria-label="Close bag">×</button>
      </div>
      <div class="drawer-items"></div>
      <div class="drawer-foot">
        <div class="drawer-total"><span>Subtotal</span><span class="drawer-subtotal">$0.00</span></div>
        <a class="btn btn-dark" href="/checkout">Checkout</a>
        <p class="drawer-note">Orders typically ship within 1–2 business days.</p>
      </div>
    </aside>`;
  document.body.appendChild(drawer);
  const itemsEl = drawer.querySelector('.drawer-items');
  const subtotalEl = drawer.querySelector('.drawer-subtotal');
  const checkoutBtn = drawer.querySelector('.drawer-foot .btn');

  function render(cart, bump) {
    const n = cart.item_count || 0;
    if (countEl) {
      countEl.textContent = n;
      countEl.hidden = n === 0;
      cartBtn.setAttribute('aria-label', `Shopping bag, ${n} item${n === 1 ? '' : 's'}`);
    }
    if (bump && cartBtn) {
      cartBtn.classList.remove('bump');
      void cartBtn.offsetWidth; // restart the animation
      cartBtn.classList.add('bump');
    }
    itemsEl.innerHTML = cart.items && cart.items.length
      ? cart.items.map((item) => {
        const variant = item.variant_title && !/default title/i.test(item.variant_title) ? `${e(item.variant_title)} · ` : '';
        const plan = item.selling_plan_allocation ? `${e(item.selling_plan_allocation.selling_plan.name)} · ` : '';
        const img = item.image ? `${item.image}${item.image.indexOf('?') === -1 ? '?' : '&'}width=200` : '';
        return `
          <div class="bitem">
            ${img ? `<img src="${e(img)}" alt="">` : '<span></span>'}
            <div><strong><a href="${e(item.url)}">${e(item.product_title)}</a></strong><span>${variant}${plan}Qty ${item.quantity}</span></div>
            <div class="bitem-side">
              <span>${money(item.final_line_price)}</span>
              <button type="button" class="bitem-rm" data-remove="${e(item.key)}">Remove</button>
            </div>
          </div>`;
      }).join('')
      : '<p class="drawer-empty">Your bag is empty.</p>';
    subtotalEl.textContent = money(cart.total_price || 0);
    checkoutBtn.classList.toggle('is-disabled', n === 0);
    checkoutBtn.setAttribute('aria-disabled', String(n === 0));
  }

  const refresh = (bump) => fetch('/cart.js', { headers: json, credentials: 'same-origin' })
    .then((r) => r.json())
    .then((cart) => { render(cart, bump); return cart; })
    .catch(() => null);

  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.querySelector('.drawer-close').focus();
  }
  function close() {
    if (!drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (cartBtn) cartBtn.focus();
  }

  drawer.addEventListener('click', (ev) => {
    if (ev.target.closest('[data-close]')) close();
    if (ev.target.closest('.drawer-foot .btn.is-disabled')) ev.preventDefault();
    const rm = ev.target.closest('[data-remove]');
    if (rm) {
      rm.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 }) })
        .then((r) => r.json())
        .then((cart) => render(cart, false))
        .catch(() => refresh(false));
    }
  });
  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') close(); });
  if (cartBtn) cartBtn.addEventListener('click', open);

  // id = product handle, option = color/shade name, plan = 'sub' for Subscribe & Save
  async function add(id, qty, option, plan) {
    let product;
    try {
      const r = await fetch(`/products/${encodeURIComponent(id)}.js`, { headers: json, credentials: 'same-origin' });
      if (!r.ok) throw new Error('not found');
      product = await r.json();
    } catch (err) {
      showToast('Coming soon. Join the Inner Circle to hear first.');
      return false;
    }
    const variants = product.variants || [];
    // Shades match by number (#1B, #4/27) so naming differences between the site and Shopify can't
    // add the wrong shade; products sold in several lengths also match the length in the handle.
    const shadeCode = (s) => ((String(s || '').match(/#\s*([0-9A-Z]+(?:\s*\/\s*[0-9A-Z]+)?)/i) || [])[1] || '').replace(/\s+/g, '').toUpperCase();
    const lengthDigits = (String(id).match(/(\d{2})-(\d{2})/) || []).slice(1).join('');
    const isLength = (o) => /[”"]|inch|\d{2}\s*[-–]\s*\d{2}/i.test(o);
    const rightLength = (v) => {
      const opts = v.options || [];
      if (!lengthDigits || !opts.some(isLength)) return true;
      return opts.some((o) => isLength(o) && o.replace(/\D/g, '') === lengthDigits);
    };
    let variant = option ? variants.find((v) => (v.title === option || (v.options || []).includes(option)) && rightLength(v)) : null;
    if (!variant && option && shadeCode(option)) {
      const code = shadeCode(option);
      variant = variants.find((v) => (v.options || []).some((o) => shadeCode(o) === code) && rightLength(v));
      if (!variant) {
        showToast(`${option} isn’t available online yet. Contact us and we’ll help with this shade.`);
        return false;
      }
    }
    if (!variant) variant = variants.find((v) => v.available) || variants[0];
    if (!variant) return false;
    const item = { id: variant.id, quantity: qty || 1 };
    if (plan === 'sub') {
      const group = (product.selling_plan_groups || [])[0];
      if (group && group.selling_plans && group.selling_plans[0]) item.selling_plan = group.selling_plans[0].id;
    }
    const res = await fetch('/cart/add.js', { method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify({ items: [item] }) });
    if (!res.ok) {
      const errBody = await res.json().catch(() => ({}));
      showToast(errBody.description || 'Sorry, this item is unavailable right now.');
      return false;
    }
    await refresh(true);
    open();
    return true;
  }

  refresh(false);
  return { add, open, refresh };
})();

// Any button with data-add="<product handle>" adds to the bag.
document.addEventListener('click', (e) => {
  const btn = e.target.closest('button[data-add]');
  if (!btn) return;
  const qtyInput = btn.dataset.qtyFrom ? document.getElementById(btn.dataset.qtyFrom) : null;
  const qty = qtyInput ? Math.min(10, Math.max(1, parseInt(qtyInput.value, 10) || 1)) : 1;
  LC.bag.add(btn.dataset.add, qty, btn.dataset.option);

  if (btn.classList.contains('fcard-add')) {
    btn.classList.add('is-added');
    clearTimeout(btn.resetTimer);
    btn.resetTimer = setTimeout(() => btn.classList.remove('is-added'), 1600);
    return;
  }
  if (!btn.dataset.label) btn.dataset.label = btn.textContent;
  btn.textContent = 'Added to Bag';
  btn.classList.add('is-added');
  clearTimeout(btn.resetTimer);
  btn.resetTimer = setTimeout(() => {
    btn.textContent = btn.dataset.label;
    btn.classList.remove('is-added');
  }, 1600);
});

// ---------- Hide Subscribe & Save where Shopify has no subscription plan ----------
document.querySelectorAll('.purchase-wrap').forEach((wrap) => {
  const page = window.LC_PAGE || {};
  if (!page.hasPlans) {
    wrap.remove();
    const add = document.getElementById('pdp-add');
    const once = document.getElementById('plan-once');
    if (once) once.checked = true;
    if (add && /^Subscribe/.test(add.textContent)) add.textContent = add.textContent.replace(/^Subscribe/, 'Add to Bag');
  }
});

// ---------- Homepage: collection tiles ----------
const homeCollections = document.getElementById('home-collections');
if (homeCollections) {
  homeCollections.innerHTML = (LC.homeCollectionOrder || LC.collectionOrder).map(LC.collectionTileHTML).join('');
}

// ---------- Homepage: latest Journal stories ----------
const homeJournal = document.getElementById('home-journal');
if (homeJournal && LC.journal) {
  homeJournal.innerHTML = LC.journal().slice(0, 3).map(LC.storyCardHTML).join('');
}

// ---------- Homepage: running trust line (duplicate items for a seamless loop) ----------
const trustTrack = document.querySelector('.trust-marquee .trust-inner');
if (trustTrack) {
  trustTrack.querySelectorAll('[data-clone]').forEach((c) => c.remove());
  const originals = Array.from(trustTrack.children);
  for (let i = 0; i < 3; i++) {
    originals.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      trustTrack.appendChild(clone);
    });
  }
}

// ---------- Homepage: Hair Notes (hover a finish to reveal its image) ----------
const hairNotes = document.querySelector('.hair-notes');
if (hairNotes) {
  const noteImgs = hairNotes.querySelectorAll('.notes-media img');
  const noteLinks = Array.from(hairNotes.querySelectorAll('.notes-list a'));
  const noteCaption = hairNotes.querySelector('.notes-caption');
  const activateNote = (i) => {
    noteImgs.forEach((img) => img.classList.toggle('is-on', img.dataset.note === String(i)));
    noteLinks.forEach((a, j) => a.classList.toggle('is-on', j === i));
    if (noteCaption && noteLinks[i]) noteCaption.textContent = noteLinks[i].querySelector('.p').textContent;
  };
  noteLinks.forEach((a, i) => {
    a.addEventListener('mouseenter', () => activateNote(i));
    a.addEventListener('focus', () => activateNote(i));
  });
  if (noteLinks.length) activateNote(0);
}

// ---------- Homepage: best sellers grid (8 products, 2 rows) ----------
const homeGrid = document.getElementById('home-grid');
if (homeGrid) {
  homeGrid.innerHTML = LC.featured().slice(0, 8).map(LC.featureCardHTML).join('');
}

// ---------- Reveal on scroll ----------
const revealEls = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach((el) => observer.observe(el));
} else {
  revealEls.forEach((el) => el.classList.add('visible'));
}

// ---------- Homepage SEO ----------
if (document.body.dataset.page === 'index' && LC.seo) {
  const title = 'Le Chic Beauty | Infrared Hair Tools, Caviar Hair Care & Extensions';
  const description = 'Shop Le Chic Beauty infrared flat irons, blow dryers and curling wands, Repairing Caviar hair care and 100% Remy human hair extensions. Lifetime tool warranty.';
  LC.seo({
    title,
    description,
    path: '/',
    image: 'images/h-1.jpg',
    imageAlt: 'Le Chic Beauty campaign: model with a glossy dark bob on a Paris balcony',
    jsonld: [
      LC.webPageLd('WebPage', '/', title, description, { about: { '@id': `${LC.SITE}#organization` } }),
      LC.itemListLd(LC.featured(), '/', 'Best-selling Le Chic Beauty hair care'),
      {
        '@type': 'ItemList',
        '@id': `${LC.SITE}#collections`,
        name: 'Le Chic Beauty collections',
        itemListElement: LC.collectionOrder.map((k, i) => ({ '@type': 'ListItem', position: i + 1, name: LC.collections[k].name, url: LC.abs(LC.collectionUrl(k)) }))
      }
    ]
  });
}
